import { render } from "./loader.vue?vue&type=template&id=30456791&scoped=true"
const script = {}

import "./loader.vue?vue&type=style&index=0&id=30456791&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30456791"]])

export default __exports__